// Show canada popup if country is Canada
function ipLookUp () {
  // vanilla ajax version
  var request = new XMLHttpRequest();
  request.open('GET', 'https://pro.ip-api.com/json?key=Sk38NLZwUwtD0Cl', true);

  request.onload = function() {
    if (request.status >= 200 && request.status < 400) {
      // Success!
      var data = JSON.parse(request.responseText);
      //console.log(data);
      
      if (
        (window.location.pathname.indexOf('/en-ca') > -1) || 
        (data.countryCode === 'CA' && window.localStorage.getItem('seen-canada-popup') !== 'true')
      ) {
        window.localStorage.setItem('seen-canada-popup', 'true');
        const canadaDialog = document.querySelector('.cmp-footer__canada-dialog');
        canadaDialog.showModal();
      }
      
    } else {
      // We reached our target server, but it returned an error
      console.log('error')
    }
  }

  request.onerror = function() {
    // There was a connection error of some sort
  }

  request.send();
}
ipLookUp()

// Forward to orthoticsdirect.ca if country is Canada
/*
const country_selector = document.querySelector('.cmp-footer__countries-select');

country_selector.addEventListener('change', (e) => {
  e && e.preventDefault();
  if (event.target.value === 'CA') {
    window.location.href = 'https://orthoticsdirect.ca';
  }
});
*/